import { Box, type BoxProps, styled } from '@mui/material';
import type { FC, ReactNode, Ref } from 'react';

export const BadgeInternal = styled('div')({
  borderRadius: '7px',
  padding: '3px 9px',
  color: 'white',
  fontWeight: '700',
  fontSize: '12px',
  textAlign: 'center',
  display: 'inline-flex',
  alignItems: 'center',
  gap: 4,
  whiteSpace: 'nowrap',
});

type BadgeProps = {
  color?: string;
  text?: string;
  endIcon?: ReactNode;
};

type Props = Omit<BoxProps<'div', BadgeProps>, 'children' | 'ref'> & { ref?: Ref<HTMLDivElement> };

export const Badge: FC<Props> = ({ color, text, endIcon, ...rest }) => (
  <BadgeInternal style={{ backgroundColor: color }} {...rest}>
    {text}
    {endIcon && (
      <Box display="flex" justifyContent="center">
        {endIcon}
      </Box>
    )}
  </BadgeInternal>
);
